import {observable, action, runInAction} from 'mobx'
import {json} from '../../../../utils/ajax'
import {handleSearchAndPage, setStore, ValueObjToObj} from "../../../../utils/Utils";

class newBOMManagementStore {
    @observable list   //总成散件列表
    @observable loading //列表loading
    @observable pagination //总成散件库分页
    @observable searchFiles //主页面搜索值绑定
    @observable carList //车系
    @observable carCode   //车系code
    @observable carMaterialCode   //实例化导出
    @observable selExportModal   //导出模态框

    constructor() {
        this.list = []
        this.loading = false
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.carList = []
        this.carCode = ''
        this.searchField = {
            carseriesCode:'',
            materialCode:'',
            materialName:''
        }
        this.selExportModal=false
        this.carMaterialCode=''

    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /***搜索表单绑值**/
    @action
    onSearchField = (changedFields) => {
        this.searchField = {...this.searchField, ...ValueObjToObj(changedFields)}
    }

    /****获取车系***/
    @action
    initCarseries = async () => {
       const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/carSeriesUnderPullFrame`)
        runInAction(() => {
            this.carList = Array.isArray(res) ? res : []
            // this.carList = arr.filter(item=>item.carSeriesCode !=='S32')
        })
    }


    /** 右侧总成列表**/
    @action
    initPage = async (page) => {
        this.loading = true
        let searchField = {
            carseriesCode:this.carCode ? this.carCode : '',
            materialCode:this.searchField.materialCode ? this.searchField.materialCode :'',
            materialName:this.searchField.materialName ? this.searchField.materialName :''
        };
        let search = handleSearchAndPage(page, this.pagination,searchField)
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/instantiateTheCorrespondingPartInformation:search`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.list = res ? res.content : []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
        })
    }
}

export default new newBOMManagementStore()


// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/sbom/NewBOMManagement/store.js